<template>
    <div v-show="radio1 === 'Variants'">
        <ShippingPopover
        ref="ShippingPopover"
        :ShippingList="ShippingList"
        :currency="storeSettings.currency"
        :defaultReceivingCountry="storeSettings.defaultReceivingCountry"
        :detailObj="detailObj"
        :submitMode="submitMode"
        @submit="shippingSubmit"
        @warehouseChange="wareHouseCode => warehouseChange(wareHouseCode, detailObj)"
        ></ShippingPopover>
        <el-table :data="detailObj.variants" class="variants" style="margin-bottom: 20px" @select-all="selectAll" @select="selectTr" ref="tableData" :reserve-selection="true" row-key="id">
            <el-table-column width="30" type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column :label="$t('publishEdit.Product')" prop="Product" align="center" width="80">
                <template slot-scope="scope">
                  <el-popover placement="right" width="280" trigger="hover">
                    <el-image  fit="cover"  :src="scope.row.imageUrl" ></el-image>
                    <el-image slot="reference" :src="scope.row.imageUrl" fit="cover" style="width: 64px;height: 64px" :class="{disabledColumn: scope.row.status === 0}" />
                  </el-popover>
                </template>
            </el-table-column>
            <el-table-column  label="SKU" prop="SKU" width="145">
                <template slot-scope="scope">
                    <!-- 新增时只给skuCode,将值附上之后重新绑定sku,编辑时是sku -->
                    <el-input type="textarea" resize="none" v-model.trim="scope.row.sku" ></el-input>
                </template>
            </el-table-column>
            <!-- 动态变体 -->
            <template v-if="platformCode === 'WC' && submitMode === 'edit'">
              <el-table-column v-for="(item, index) in detailObj.attributes" :key="item.id" :label="item.name" :prop="`option${index+1}`" width="90" >
                  <template slot-scope="scope">
                      <el-input v-model="scope.row[`option${index+1}`]" v-if="!platformName.toLocaleUpperCase().includes('LAZZA')" class="borderTo2"></el-input>
                      <span v-else>{{scope.row[`option${index+1}`]}}</span>
                  </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column v-for="(item, index) in detailObj.options" :key="item.id" :label="item.name" :prop="`option${index+1}`" width="90" >
                  <template slot-scope="scope">
                      <el-input v-model="scope.row[`option${index+1}`]" v-if="!platformName.toLocaleUpperCase().includes('LAZZA')" class="borderTo2"></el-input>
                      <span v-else>{{scope.row[`option${index+1}`]}}</span>
                  </template>
              </el-table-column>
            </template>
            <el-table-column :label="$t('publishEdit.Quantity')" prop="inventoryQuantity" width="80"></el-table-column>
            <el-table-column v-if="platformCode === 'TT'" :label="$t('publishEdit.WarehouseName')" prop="warehouseId" width="160">
              <template slot="header" v-if="detailObj.ttWarehouseList && detailObj.ttWarehouseList.length">
                <TTWarehouseBatch :submitMode="submitMode" :ttWarehouseList="detailObj.ttWarehouseList" @batch="warehouseBatch"></TTWarehouseBatch>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.warehouseId" :disabled="submitMode==='edit'" class="warehouse-list">
                  <el-option :label="item.warehouseName" :value="item.warehouseId" v-for="item in detailObj.ttWarehouseList" :key="item.warehouseId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('publishEdit.ProductCost')" prop="originalPrice" width="112">
                <template slot-scope="scope">
                {{`${storeSettings.currency} ${scope.row.originalPrice || ''}`}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('publishEdit.ShippingCost')" prop="shippingCost" width="116">
                <template slot-scope="scope">
                {{`${storeSettings.currency} ${scope.row.shippingCost || ''}`}}
                </template>
            </el-table-column>
            <!-- suggested price   销售价格   字段为price -->
            <el-table-column prop="price" width="167">
                <template slot="header">
                    <priceRadio :title="$t('Publish.Edit.Components.Variants.SuggestedPrice')" @change="priceRadioConfirm" :currency="storeSettings.currency"></priceRadio>
                </template>
                <template slot-scope="scope">
                    {{storeSettings.currency}} <el-input v-model="scope.row.price" style="width: 90px" @input="value => tableInputChange(scope.row, value, 'price')" @blur="value => priceInputBlur(value, scope.row, 'price')" class="borderTo2"></el-input>
                </template>
            </el-table-column>
            <!-- 对比价格 -->
            <el-table-column v-if="platformCode !== 'TT'" prop="compareAtPrice" width="167">
                <template slot="header">
                    <priceRadio :title="$t('Publish.Edit.Components.Variants.CompareAtPrice')" @change="priceRadioConfirm" :currency="storeSettings.currency"></priceRadio>
                </template>
                <template slot-scope="scope">
                    {{storeSettings.currency}}
                    <el-input
                    :class="{redBorder: compareAtPriceIsRed(scope.row)}"
                    v-model="scope.row.compareAtPrice"
                    style="width: 90px"
                    @input="value => tableInputChange(scope.row, value, 'compareAtPrice')"
                    @blur="value => priceInputBlur(value, scope.row, 'compareAtPrice')"
                    class="borderTo2"></el-input>
                </template>
            </el-table-column>
            <el-table-column :label="$t('publishEdit.Profi')" prop="Profi" width="90">
                <template slot-scope="scope">
                <div :class="{redFont: profiCheck(scope.row)}">{{`${storeSettings.currency} ${scope.row.Profi || ''}`}}</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import _ from 'lodash'
import ShippingPopover from './ShippingPopover.vue'
import priceRadio from './priceRadio.vue'
import API from '@/api'
import bus from '@/util/bus'
import TTWarehouseBatch from './TTWarehouseBatch.vue'
const numToFixedTwo = (num) => {
  return parseFloat(num.toFixed(2))
}
export default {
  components: { ShippingPopover, priceRadio, TTWarehouseBatch },
  props: {
    detailObj: {
      type: Object,
      default: () => ({
        'productId': undefined,
        'kkProductId': undefined,
        'title': undefined,
        'bodyHtml': undefined,
        'listingStatus': undefined,
        'tags': undefined,
        'storeName': undefined,
        'variants': [],
        'options': [],
        'images': [],
        'id': undefined,
        'storeId': undefined,
        'listingId': undefined,
        'collectionId': undefined,
        'collectionName': undefined,
        'imageUrl': undefined,
        productType: undefined
      })
    },
    storeSettings: {
      type: Object,
      default: () => ({ currency: '' })
    },
    imageList: {
      type: Array,
      default: () => []
    },
    radio1: {
      type: String,
      default: () => ''
    },
    submitMode: {
      type: String,
      default: () => 'add'
    },
    getDetailParams: {
      type: Object,
      default: () => ({})
    },
    platformCode: {
      type: String,
      default: () => ''
    },
    sizeImagePath: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    CompareAtPriceCheck() {
      if (this.getDetailParams.platformCode === 'DJ') return this.$t('publishEdit.CompareAtPriceCheckShoplazza')
      return this.$t('publishEdit.CompareAtPriceCheck')
    },
    platformName() {
      let name = ''
      let target = this.$store.state.common.platformOptions.find(e => e.platformCode === this.platformCode) || { platformName: '' }
      name = target.platformName || this.$route.query.platformName
      return name
    }
  },
  data() {
    return {
      ShippingList: [],
      logistics: {},
      imagesBatch: true,
      shippingObj: undefined
    }
  },
  methods: {
  // 获取运费并重新计算sku各价格
    shippingSubmit(obj) {
      if (obj) {
        this.shippingObj = obj
        this.detailObj.variants.forEach(e => {
          this.$set(e, 'shippingCost', obj.estimatedFreight)
          const that = this
          setTimeout(() => {
            that.computerPrice(e)
          }, 100)
        })
      }
    },
    // 发货地下拉事件，新增时sku需由仓库带出，并重新渲染可选择图片  只有新增才用到
    warehouseChange(warehouseCode, detailObj) {
      if (this.submitMode === 'add') {
        let target = detailObj.otherWareHouseSkus.find(e => e.warehouseCode === warehouseCode)
        if (!target) return
        detailObj.warehouseCode = warehouseCode
        detailObj.variants = target.variants
        this.imageList.splice(0)
        this.$refs.tableData.clearSelection()
        this.$nextTick(() => {
          detailObj.variants.forEach(e => {
            this.$refs.tableData.toggleRowSelection(e, true)
          })
          this.$nextTick(() => {
            this.skuChangeImageHandle(this.$refs.tableData.selection)
          })
        })
        // 默认全部勾选
        this.imagesBatch = true
        // 更改仓库，并根据仓库获取收货地  清空渠道
        this.$refs.ShippingPopover.setShippingFrom(warehouseCode)
        this.ShippingList = []
      }
    },
    // sku带出图片 默认只勾选每个sku的前四张
    skuChangeImageHandle(selection) {
      let imageList = []
      selection.forEach(e => {
        e.images.forEach((img, imgIndex) => {
          let haveRepeat = imageList.find(i => {
            if (i.src) return i.src === img.imgUrl
            else i.imgUrl === img.imgUrl
          })
          if (haveRepeat) {
            haveRepeat.ids.push(e.id)
          } else {
            img.ids = [e.id]
            this.$set(img, 'isChecked', imgIndex < 4)
            imageList.push(img)
          }
        })
      })
      // 图片列表判断主图不可取消勾选，做一遍校验，防止图片url相同status不同出现错误
      imageList.forEach(img => {
        let target = selection.find(e => e.imageUrl === img.imgUrl)
        if (target) {
          img.status = 1
          img.isChecked = true
        }
      })
      // 如果有尺寸图 (8.15 TT平台不插入尺码图)
      if (this.sizeImagePath && this.platformCode !== 'TT') {
        let sizeImagePath = { src: this.sizeImagePath, isChecked: true, imgUrl: this.sizeImagePath, status: 0 }
        imageList.splice(1, 0, sizeImagePath)
      }
      // (8.15 TT平台图片选取逻辑， 先选择产品主图，在按循序选中前九张，超出的都不选中)
      if (this.platformCode === 'TT') {
        let TTImageList = []
        TTImageList = imageList.filter(img => img.status)
        imageList.forEach(img => {
          if (!TTImageList.some(t => t.imgUrl === img.imgUrl)) TTImageList.push(img)
        })
        TTImageList.forEach((img, i) => {
          if (i > 8) {
            img.status = 0
            img.isChecked = false
          } else img.isChecked = true
        })
        imageList = TTImageList
      }
      if (this.$route.query.updateProcessed && +this.$route.query.updateProcessed === 2) {
        // 店铺设置没勾选图片时，删除新增的尺码表，用旧的（listingImageVOS）内的尺码表
        if (this.sizeImagePath && this.platformCode !== 'TT' && this.storeSettings.listingUpdateConfList && !this.storeSettings.listingUpdateConfList.includes('Images')) {
          imageList.splice(1, 1)
        }
        let target = this.detailObj.otherWareHouseSkus.find(e => e.warehouseCode === this.detailObj.warehouseCode)
        if (target && target.listingImageVOS) {
          let newimageList = target.listingImageVOS.map(item => ({
            ...item,
            imgUrl: item.src,
            isChecked: true
          }))
          // // 取差集  arrB相对于arrA所没有的
          // let res5 = arrObjB.filter(itemB => !arrObjA.find(itemA => itemA.code == itemB.code))
          imageList = imageList.concat(newimageList)
        }
      }
      bus.$emit('skuChangeImageHandle', imageList)
      this.topBigImageChange(imageList)
    },
    // 新增状态下  获取顶部主图
    topBigImageChange(imageList) {
      const target = imageList.find(e => e.status === 1 && e.isChecked)
      let imageUrl = ''
      if (target) {
        imageUrl = target.imgUrl || target.imageUrl
      } else {
        imageUrl = ''
      }
      this.$emit('changeImageUrl', imageUrl)
    },
    // 全选/取消选操作
    selectAll(selection) {
      if (this.submitMode === 'add') {
        this.skuChangeImageHandle(selection)
      }
    },
    // 选择某行
    selectTr(selection, row, isAllClick) {
      // 新增需要将sku下的图片带出选择，没选中则去除
      if (this.submitMode === 'add') {
        this.skuChangeImageHandle(selection)
      }
      // 编辑里  是否是未刊登成功过的编辑  图片与sku仍然有关联  勾选上的对应图片才能选择
      if (this.getDetailParams.isListingQueueStatusAndPublishFail) {
        this.skuChangeImageHandle(selection)
      }
    },
    // 销售价格  比对价格表头弹窗确认
    priceRadioConfirm(obj) {
      // SuggestedPrice 销售价  compareAtPrice 对比价
      // 最终值   赋值类型（百分比还是直接赋值）  字段（SuggestedPrice 销售价  compareAtPrice 对比价）  numToFixedTwo
      const { final, which, title } = obj
      // 如果是对比价，有比销售价小时要给出消息提示
      let compareAtPriceIsLessThanPrice = false
      this.detailObj.variants.forEach(e => {
        let price
        if (final && !Number.isNaN(final)) {
          if (which === 'PercentageV') {
            price = numToFixedTwo((e.originalPrice * 1000) * (final * 1000) / 1000000)
          } else {
            // FixedProfit 固定利润
            price = numToFixedTwo(+e.originalPrice + +final)
          }
        }
        // let shippingCoat = this.shippingObj ? this.shippingObj.estimatedFreight : 0 // 前同事代码
        let shippingCoat = this.shippingObj ? this.shippingObj.estimatedFreight : e.shippingCost
        if (which === 'PercentageV' || which === 'FixedProfit') {
        // 按百分比
          if (final && !Number.isNaN(final)) {
            price = (((price * 1000) + (shippingCoat * 1000)) / 1000)
            price = numToFixedTwo(price)
          } else {
            price = undefined
          }
          // 销售价格
          title === 'SuggestedPrice' ? this.$set(e, 'price', price) : this.$set(e, 'compareAtPrice', price)
          let Profi = numToFixedTwo((((e.price * 1000) - (e.originalPrice * 1000)) / 1000 - shippingCoat))
          if (title === 'SuggestedPrice') {
            if (this.detailObj.taskNo) {
              this.onTaskNoGetShippingCost()
            } else {
              e.Profi = Profi
            }
          }
        } else if (which === 'OneClickModificationV') {
        // 一键更改
          title === 'SuggestedPrice' ? this.$set(e, 'price', final) : this.$set(e, 'compareAtPrice', final)
          let Profi = numToFixedTwo((((e.price * 1000) - (e.originalPrice * 1000)) / 1000 - shippingCoat))
          if (title === 'SuggestedPrice') {
            if (this.detailObj.taskNo) {
              this.onTaskNoGetShippingCost()
            } else {
              e.Profi = Profi
            }
          }
        }
        // 比对价格必须比销售价格大
        if (e.price > e.compareAtPrice) {
          compareAtPriceIsLessThanPrice = true
        }
      })
      compareAtPriceIsLessThanPrice && this.$message.error(this.$t('promptText.msg45'))
    },
    compareAtPriceIsRed(row) {
      let compareAtPrice = row.compareAtPrice
      let price = row.price
      let isLessThan = false
      if (typeof price !== 'number') {
        return isLessThan
      }
      if (typeof compareAtPrice !== 'number') {
        return isLessThan
      }
      if (this.getDetailParams.platformCode !== 'DJ' && compareAtPrice <= price) {
        isLessThan = true
      }
      if (this.getDetailParams.platformCode === 'DJ' && compareAtPrice < numToFixedTwo((price * (100 / 99.5)))) {
        isLessThan = true
      }
      return isLessThan
    },
    // 表格内输入框  销售价、比对价
    tableInputChange(row, value, key) {
    // row[key] = num.replace(/[^\d.]/g, '')
      if (value) {
        row[key] = value.replace(/[^\d.]/g, '')
      } else {
        row[key] = undefined
      }
      // this.computerPrice(row)
      // 计算利润
      if (key === 'price') {
        let shippingCost = row.shippingCost ? row.shippingCost : 0
        let originalPrice = row.originalPrice ? row.originalPrice : 0
        let Profi = null
        if (row.price) {
          Profi = row.price - shippingCost - originalPrice
        } else {
          Profi = 0
        }
        this.$set(row, 'Profi', numToFixedTwo(Profi))
      }
    },
    // 输入框失去焦点
    priceInputBlur(value, row, which) {
      if (value.target.value) this.$set(row, which, parseFloat(parseFloat(value.target.value).toFixed(2)))
      if (which === 'compareAtPrice') {
      // 对比价格必须比销售价格大
        if (row.compareAtPrice !== undefined) {
          let isPass = row.compareAtPrice > row.price
          if (this.getDetailParams.platformCode === 'DJ') {
            isPass = row.compareAtPrice >= numToFixedTwo((row.price * (100 / 99.5)))
          }
          if (!isPass) {
            let final = numToFixedTwo((row.price * (100 / 99.5)))
            this.$message.error(`${this.CompareAtPriceCheck}  minimum:${final}`)
          }
        }
      }
      if (which === 'price' && this.detailObj.taskNo) {
        this.onTaskNoGetShippingCost()
        // const target = this.$refs.ShippingPopover.ShippingList.find(e => e.checked)
        // this.detailObj.variants.forEach(e => {
        //   e.shippingCost = target.estimatedFreight
        //   this.$set(e, 'Profi', +(e.price - e.originalPrice - e.shippingCost).toFixed(2))
        // })
      }
    },
    // 计算价格  基于原价计算
    computerPrice(e, first = false) {
      /*
          销售价格 = 原价 * 定价比例 + 运费  price = originalPrice * priceRatio + shippingCost
          对比价格 = 原价 * 比价比例 + 运费  compareAtPrice = originalPrice * compareRatio + shippingCost
          利润 = 售价 - 原价
          新增时
          (1)店铺设置配了价格比例  ----> 实时通过公式实时计算价格
          (2)店铺设置没配价格比例  ----> 不计算为空
          编辑时
          (1)店铺设置配了价格比例  ----> 每次点击编辑都重新算价格
          (2)店铺设置没配价格比例  ----> 编辑时"售价"和"对比价格"采用后台返回的价格(但成本价和运费需要用实时的)
        */
      this.$nextTick(() => {
        if (!this.storeSettings) {
          return
        }
        let shippingCost = e.shippingCost || 0
        let priceRatio = this.storeSettings.priceRatio || null
        let compareRatio = this.storeSettings.compareRatio || null
        let originalPrice = e.originalPrice ? e.originalPrice : 0
        // 销售价格为原价 Suggested Price 的key 为price
        let price = e.price
        let compareAtPrice = e.compareAtPrice
        if (priceRatio) {
          price = numToFixedTwo((((originalPrice * 1000) * (priceRatio * 1000) + (shippingCost * 1000000)) / 1000000))
        }
        let Profi = numToFixedTwo((price - originalPrice - shippingCost))
        this.$set(e, 'price', Number.isNaN(price) ? null : price)
        this.$set(e, 'Profi', Number.isNaN(Profi) ? null : Profi)
        if (compareRatio && !first) {
          compareAtPrice = numToFixedTwo((((originalPrice * 1000) * (compareRatio * 1000) + (shippingCost * 1000000)) / 1000000))
        } else if (this.submitMode === 'edit') {
          compareAtPrice = e.compareAtPriceBar
        }
        if (!e.compareAtPrice) {
          if (compareAtPrice === 0) compareAtPrice = null
          else this.$set(e, 'compareAtPrice', Number.isNaN(compareAtPrice) ? null : compareAtPrice)
        }
      })
    },
    EditfirstLoad() {
    // 队列中或者刊登失败
      if (this.getDetailParams.listingStatus === '4' && this.getDetailParams.isListingQueueStatusAndPublishFail) {
        this.$nextTick(() => {
          this.detailObj.variants.forEach(e => {
            this.$refs.tableData.toggleRowSelection(e, e.isChecked)
            this.imageList.forEach(img => {
              if (img.skuCode === e.skuCode) {
                this.$set(img, 'disabled', !e.isChecked)
                this.$set(img, 'isChecked', e.isChecked)
              }
            })
            // 保留原价格  原字段可修改
            if (e.compareAtPrice === 0) e.compareAtPrice = null
            e.priceBar = e.price
            e.compareAtPriceBar = e.compareAtPrice
            e.costPrice = e.originalPrice
            this.computerPrice(e, true)
          })
        })
      } else {
      // 其他情况全都默认勾选
        this.$nextTick(() => {
          this.detailObj.variants.forEach(e => {
            this.$set(e, 'isChecked', true)
            this.$refs.tableData.toggleRowSelection(e, true)
            // 保留原价格  原字段可修改
            if (e.compareAtPrice === 0) e.compareAtPrice = null
            e.priceBar = e.price
            e.compareAtPriceBar = e.compareAtPrice
            e.costPrice = e.originalPrice
          })
          this.imageList.forEach(img => {
            this.$set(img, 'isChecked', true)
          })
        })
      }
      // logistics 发货地收货地运费缓存对象
      this.logistics = this.detailObj.logistics || undefined
      // 变体获取
      this.detailObj.options = this.detailObj.options.filter(e => e.name)
      this.EditFirstLoadPublishGetWarehouseStock().then(() => {
        const { receivingCountryCode = 'US', channelCode, warehouseCode, warehouseId, warehouseType: channelGrouping } = this.logistics
        let params
        params = {
          warehouses: [{
            warehouseCode,
            termini: receivingCountryCode,
            channelGrouping,
            warehouseId,
            products: [{
              skuCode: this.detailObj.variants[0].skuCode,
              quantity: 1,
              kkProductId: this.detailObj.kkProductId
            }],
            platformCode: this.platformCode
          }],
          currency: this.getDetailParams.currency
        }
        API.publishGetChannel(params).then(res => {
          if (res.data[0].code === 10000) {
            const channelList = res.data[0].data
            channelList.forEach(e => {
              this.$set(e, 'checked', false)
            })
            let t = null
            if (channelCode) {
              if (channelList.find(e => e.channelCode === channelCode)) {
                t = channelList.find(e => e.channelCode === channelCode)
              } else {
                t = channelList[0]
              }
            } else {
              t = channelList[0]
            }
            this.detailObj.variants.forEach(e => {
              // if (!this.detailObj.taskNo) {
              e.shippingCost = t.estimatedFreight
              this.$nextTick(() => {
                this.$refs.ShippingPopover.setShippingList(channelList, t.channelCode)
              })
              // }
              let shippingCost = e.shippingCost || 0
              this.$set(e, 'Profi', +(e.price - e.originalPrice - shippingCost).toFixed(2))
            })
          } else {
            this.$message.error(res.data[0].message)
          }
        })
      })
    },
    // 根据skuCode获取仓库信息
    EditFirstLoadPublishGetWarehouseStock() {
      return new Promise((resolve, reject) => {
        let skuCodes = this.detailObj.variants.map(e => e.skuCode)
        API.publishGetWarehouseStock({ skuCodes: skuCodes[0] }).then(res => {
          let ShippingFromSelectList = res.data
          // 获取到发货地  下拉列表
          ShippingFromSelectList.forEach(e => {
            // this.$set(e, 'renderName', `${e.countryCn}-${e.warehouseName}`)
            this.$set(e, 'renderName', `${e.countryCn}`)
          })
          const { warehouseCode } = this.logistics
          this.$nextTick(() => {
            this.$refs.ShippingPopover.setShippingFromSelectList(ShippingFromSelectList)
            this.$refs.ShippingPopover.setShippingFrom(warehouseCode)
          })
          resolve()
        })
      })
    },
    // 获取收货地发货地物流渠道缓存赋值  调用获取物流接口获取物流信息并赋值
    EditFirstLoadlogisticsStorageSet(logistics) {
      if (!logistics) {
      // this.$message.warning(this.$t('publishEdit.IncorrectLogisticsInformation'))
        return
      }
      const { warehouseCode, receivingCountryCode = null, channelCode = null } = logistics
      this.$nextTick(() => {
        this.$refs.ShippingPopover.setShippingFrom(warehouseCode)
        this.$refs.ShippingPopover.setShippingTo(receivingCountryCode)
        let target = this.ShippingList.find(e => e.channelCode === channelCode)
        target && this.$set(target, 'isChecked', true)
      })
      // 新增时没有选择物流渠道则不调取渠道信息
      if (!receivingCountryCode || !channelCode) {
        return
      }
      const params = {
        warehouses: [
          { ...logistics,
            channelGrouping: logistics.warehouseType,
            termini: logistics.receivingCountryCode,
            products: [{
              skuCode: this.detailObj.variants[0].skuCode,
              quantity: 1,
              kkProductId: this.detailObj.kkProductId
            }] }
        ],
        currency: this.storeSettings.currency
      }
      // 获取物流渠道信息
      this.$refs.ShippingPopover.setLoad(true)
      API.publishGetChannel(params).then(res => {
        this.$refs.ShippingPopover.setList(res.data[0].data)
        this.ShippingList = res.data[0].data
        let estimatedFreight = 0
        this.ShippingList.forEach(e => {
          this.$set(e, 'checked', e.channelCode === logistics.channelCode)
          if (e.channelCode === logistics.channelCode) {
            estimatedFreight = e.estimatedFreight
          }
        })
        // 运费赋值
        this.detailObj.variants.forEach(item => {
          this.$set(item, 'shippingCost', estimatedFreight)
        })
      }).finally(() => {
        this.$refs.ShippingPopover.setLoad(false)
      })
    },
    getlogistics() {
      return this.$refs.ShippingPopover.getlogistics()
    },
    /*
      从商品跳转过来才调用的方法
      将发货地提取出来生成下拉，并默认展示第一个发货仓库里的sku
  */
    addModeVariantsHandle(otherWareHouseSkus, detailObj) {
      if (otherWareHouseSkus && otherWareHouseSkus[0]) this.$set(detailObj, 'options', otherWareHouseSkus[0].options)
      this.$set(detailObj, 'variants', [])
      const ShippingFromSelectList = []
      if (!otherWareHouseSkus) otherWareHouseSkus = []
      otherWareHouseSkus.forEach(e => {
        const { countryCn, countryCode, warehouseCode, warehouseId, warehouseName, warehouseType } = e
        const shippingFromObj = { countryCn, countryCode, warehouseCode, warehouseId, warehouseName, warehouseType }
        // this.$set(shippingFromObj, 'renderName', `${countryCn}-${warehouseName}`)
        this.$set(shippingFromObj, 'renderName', `${countryCn}`)
        ShippingFromSelectList.push(shippingFromObj)
        e.options = e.options.filter(f => f.name)
        this.addVariantsHandle(e)
      })
      this.$refs.ShippingPopover.setShippingFromSelectList(ShippingFromSelectList)
      // 当发货国家为US时, 也将收货国家默认设置成US
      if (ShippingFromSelectList[0].countryCode === 'US') {
        this.$refs.ShippingPopover.ShippingTo = 'US'
      } else {
        // 优先取店铺设置的收货国家, 若店铺设置里没有则默认取US
        this.$refs.ShippingPopover.ShippingTo = this.storeSettings.defaultReceivingCountry || 'US'
      }

      // 新增为 仓库带出仓库下的sku   默认带出第一个仓库里面的sku
      let countrySkuIndex = 0
      if (ShippingFromSelectList.length) {
        // this.$nextTick(() => {
        // 如果店铺设置了默认发货国为美国, 且存在sku在美国有库存时, 则设置发货国为美国
        if (!this.storeSettings.defaultReceivingCountry || (this.storeSettings.defaultReceivingCountry && this.storeSettings.defaultReceivingCountry === 'US' && otherWareHouseSkus.findIndex(t => t.countryCode === 'US') >= 0)) {
          this.$refs.ShippingPopover.setShippingFrom(ShippingFromSelectList[otherWareHouseSkus.findIndex(t => t.countryCode === 'US')].warehouseCode)
          this.warehouseChange(ShippingFromSelectList[otherWareHouseSkus.findIndex(t => t.countryCode === 'US')].warehouseCode, this.detailObj)
          countrySkuIndex = otherWareHouseSkus.findIndex(t => t.countryCode === 'US')
        } else {
          this.$refs.ShippingPopover.setShippingFrom(ShippingFromSelectList[0].warehouseCode)
          this.warehouseChange(ShippingFromSelectList[0].warehouseCode, this.detailObj)
        }
        // })
        const { warehouseCode, warehouseId, warehouseType: channelGrouping } = ShippingFromSelectList[countrySkuIndex]
        const params = {
          currency: this.getDetailParams.currency,
          warehouses: [{
            warehouseCode,
            termini: this.$refs.ShippingPopover.ShippingTo,
            channelGrouping,
            warehouseId,
            // products: otherWareHouseSkus[0].variants.map(e => {
            //   return {
            //     skuCode: e.skuCode,
            //     quantity: 1,
            //     kkProductId: detailObj.kkProductId
            //   }
            // })
            products: [{
              skuCode: otherWareHouseSkus[countrySkuIndex].variants[0].skuCode,
              quantity: 1,
              kkProductId: detailObj.kkProductId
            }],
            platformCode: this.platformCode
          }]
        }
        API.getLogisticsChannel(params).then(res => {
          if (res.data[0].code === 10000) {
            res.data[0].data.forEach(e => {
              this.$set(e, 'checked', false)
            })
            let channelList = res.data[0].data
            // 当物流返回时相同类型的渠道返回了多个时，只取同类型渠道中运费最低的渠道在kaka展示
            channelList = channelList.reduce((current, next) => {
              let index = current.findIndex(e => e.agingGrade === next.agingGrade)
              if (index !== -1) {
                if (current[index].estimatedFreight > next.estimatedFreight) {
                  current.splice(index, 1)
                  current.push(next)
                }
              } else {
                current.push(next)
              }
              return current
            }, [])
            // 默认勾选第一个  并把运费赋值 // (2023/8/11: express > standard > expedited, 按这个循序取便宜的)
            let index = channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express') > -1
              ? channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express')
              : channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard') > -1
                ? channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard')
                : channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited') > -1
                  ? channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited') : 0
            otherWareHouseSkus[countrySkuIndex].variants.forEach(e => {
              this.$set(e, 'shippingCost', channelList[index].estimatedFreight)
              let priceRadio = 1
              let compareRatio = 0
              if (this.storeSettings && this.storeSettings.priceRatio) priceRadio = this.storeSettings.priceRatio
              if (this.storeSettings && this.storeSettings.compareRatio) compareRatio = this.storeSettings.compareRatio
              // 店铺设置里的 priceRatioType 为x或者+
              if (priceRadio && this.storeSettings.isPrice) {
                if (this.storeSettings.priceRatioType === '+') {
                  this.$set(e, 'price', e.updatePrice || +(e.originalPrice + priceRadio + e.shippingCost).toFixed(2))
                } else {
                  this.$set(e, 'price', e.updatePrice || +(e.originalPrice * priceRadio + e.shippingCost).toFixed(2))
                }
              }
              // 店铺设置里的 compareRatioType 为x或者+
              if (compareRatio && this.storeSettings.isComparePrice) {
                if (this.storeSettings && this.storeSettings.compareRatioType === '+') {
                  this.$set(e, 'compareAtPrice', e.updatePrice ? (e.updateCompareAtPrice || '') : +(e.originalPrice + compareRatio + e.shippingCost).toFixed(2))
                } else {
                  this.$set(e, 'compareAtPrice', e.updatePrice ? (e.updateCompareAtPrice || '') : +(e.originalPrice * compareRatio + e.shippingCost).toFixed(2))
                }
              }
              this.$set(e, 'Profi', numToFixedTwo((e.price - e.originalPrice - e.shippingCost)))
            })
            this.$nextTick(() => {
              this.$refs.ShippingPopover.setShippingList(channelList, channelList[index].channelCode)
            })
          } else {
            this.$message.error(res.data[0].message)
          }
        })
      }
    },
    /*
      将variants处理成渲染需要的格式
      每个sku下的images处理
      status为1的抽取到第一位、options处理、
    */
    addVariantsHandle(e) {
      const { countryCn, countryCode, warehouseCode, warehouseId, warehouseName, warehouseType } = e
      e.variants.forEach((item, index) => {
        item.id = index;
        ['option1', 'option2', 'option3'].forEach(key => {
          if (item[key]) {
            let value = JSON.parse(item[key])
            item[key] = value.value
          }
        })
        item = Object.assign(item, { countryCn, countryCode, warehouseCode, warehouseId, warehouseName, warehouseType })
        this.$set(item, 'sku', item.skuCode)
        item.images = this.status1ImgHandle(item)
        // 预览图取出
        this.$set(item, 'imageUrl', item.images.length ? item.images[0].imgUrl : '')
        // this.computerPrice(item)
        item.inventoryPolicy = false
        item.requiresShipping = true
        item.costPrice = item.originalPrice
        if (this.platformCode === 'TT') {
          item.warehouseId = this.detailObj.ttWarehouseList.find(item => item.isDefault).warehouseId || undefined
        }
      })
    },
    // 将status为1的图片抽到第一位  上方主图取选中第一张
    // 设置 skuCode  src
    status1ImgHandle(item) {
      let images = item.imageUrl ? JSON.parse(item.imageUrl) : []
      let status1Img
      for (let i = 0; i < images.length; i++) {
        if (images[i].status === 1) {
          status1Img = images[i]
          images.splice(i, 1)
          i = images.length
        }
      }
      if (status1Img) images = [status1Img, ...images]
      images.forEach(e => {
        e.skuCode = item.skuCode
        e.src = e.imgUrl
      })
      return images
    },
    getSelection() {
      return this.$refs.tableData.selection
    },
    profiCheck(row) {
      let shippingCost = row.shippingCost || 0
      if (row.price < (row.originalPrice + shippingCost)) return true
      return false
    },
    onTaskNoGetShippingCost() {
      if (this.detailObj.variants.every(e => e.shippingCost)) return
      this.$refs.ShippingPopover.getChannelForTaskNo().then(estimatedFreight => {
        this.detailObj.variants.forEach(e => {
          e.shippingCost = estimatedFreight
          // e.price = (e.price + e.shippingCost).toFixed(2)
          this.$set(e, 'Profi', +(e.price - e.originalPrice - e.shippingCost).toFixed(2))
        })
      })
    },

    // tt 批量修改仓库
    warehouseBatch(warehouseId) {
      this.detailObj.variants.forEach(item => {
        item.warehouseId = warehouseId
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.variants{
  /deep/ .has-gutter th .cell{
    font-size: 14px;
    font-weight: 500;
  }
}
.redBorder {
/deep/input{
  border-color: red;
  color: red;
}
}
.redFont {
color: red;
}
.fontfine {
/deep/span {
  font-weight: normal !important;
}
}
/deep/.borderTo2{
  >input{
    border-radius: 2px !important;
  }
}
.warehouse-list /deep/ .el-input__inner {
  border-radius: 2px;
}
</style>
